export const isEmpty = (value: any): boolean => {
  if (Array.isArray(value)) return !value?.length;

  switch (typeof value) {
    case 'undefined':
      return true;
    case 'string':
      return !value;

    case 'object':
      return !!value && !Object.values(value).length;

    default:
      return false;
  }
};

export function isArrayNotEmpty(arr) {
  if (arr && Array.isArray(arr) && arr.length > 0) {
    return true;
  }
  return false;
}

export function isObject(obj: any): boolean {
  return !!obj && typeof obj === 'object' && !Array.isArray(obj);
}
